import PropTypes from "prop-types";
import React, { Component, useEffect, useState } from "react";
import Overridable from "react-overridable";
import {
  Button,
  Container,
  Divider,
  Grid,
  Header,
  Icon,
} from "semantic-ui-react";
import { HomeSearchBar } from "./HomeSearchBar";
import { Link as ScrollLink } from "react-scroll";
import history from "lib/history";

const HeadlineLayout = (props) => {
  const { backgroundImageURL } = props;
  const [isMobile, setIsMobile] = useState();
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 767);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  });
  return (
    <Overridable id="Home.Headline.render">
      <Container
        fluid
        className="fs-headline-section"
        style={{
          backgroundImage: backgroundImageURL
            ? `url(${backgroundImageURL})`
            : null,
        }}
      >
        <Container fluid className="fs-headline">
          <Overridable id="Home.Headline.slogan">
            <Container className="container-header">
              <Grid>
                <Grid.Column
                  width={16}
                  textAlign="left"
                  style={{
                    marginLeft: isMobile ? "-11rem" : "0",
                    paddingTop: isMobile ? "8.5rem" : "",
                    minWidth: isMobile ? "100vw" : "",
                  }}
                >
                  <Header as="h1" className="fs-headline-header" size="huge">
                    Library Information Management System
                  </Header>
                  <Header.Subheader className="fs-headline-subheader">
                    Literature catalogue, circulation, acquisition.
                  </Header.Subheader>
                </Grid.Column>
              </Grid>
            </Container>
          </Overridable>

          <Overridable id="Home.Headline.Content">
            <Container
              data-tour="home-search-bar"
              className={`container-search ${
                isMobile ? "mobile-search-bar" : ""
              }`}
            >
              <HomeSearchBar />
              <div
                style={{
                  marginTop: isMobile ? "20px" : "25px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                  marginRight: isMobile ? "0" : "-10em",
                  paddingLeft: isMobile ? "0" : "15em",
                }}
              >
                <Button
                  size={isMobile ? "small" : "large"}
                  icon
                  labelPosition="right"
                  onClick={() => history.push("/search?mode=thesis")}
                  className="thesis-browse-button"
                  style={{
                    backgroundColor: "rgba(255, 255, 255, 0.15)",
                    border: "1px solid rgba(255, 255, 255, 0.9)",
                    color: "#ffffff",
                    fontWeight: "600",
                    fontSize: isMobile ? "12px" : "13px",
                    padding: isMobile ? "12px 20px" : "14px 28px",
                    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                    margin: "0",
                  }}
                  onMouseEnter={(e) => {
                    if (!isMobile) {
                      e.currentTarget.style.backgroundColor =
                        "rgba(255, 255, 255, 0.25)";
                      e.currentTarget.style.transform = "translateY(-2px)";
                      e.currentTarget.style.boxShadow =
                        "0 12px 40px rgba(0, 0, 0, 0.25)";
                      e.currentTarget.style.borderColor = "#ffffff";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!isMobile) {
                      e.currentTarget.style.backgroundColor =
                        "rgba(255, 255, 255, 0.15)";
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow =
                        "0 8px 32px rgba(0, 0, 0, 0.2)";
                      e.currentTarget.style.borderColor =
                        "rgba(255, 255, 255, 0.9)";
                    }
                  }}
                >
                  <Icon name="graduation cap" style={{ marginRight: "6px" }} />
                  Browse Thesis & Dissertations
                </Button>
              </div>
            </Container>
          </Overridable>

          <Overridable id="Home.Headline.extra">
            <Container className="container-extra">
              <Divider />
              <Grid data-tour="quick-buttons">
                <Grid.Column width={16} textAlign="center">
                  {!isMobile && (
                    <>
                      <Button
                        className="headline-quick-access"
                        as={ScrollLink}
                        to="recent-books"
                        offset={-100}
                        smooth
                        primary
                      >
                        Recent books
                      </Button>
                      <Button
                        className="headline-quick-access"
                        as={ScrollLink}
                        to="most-loaned"
                        offset={-100}
                        smooth
                        primary
                      >
                        Popular books
                      </Button>
                    </>
                  )}
                </Grid.Column>
              </Grid>
            </Container>
          </Overridable>
        </Container>
      </Container>
    </Overridable>
  );
};

class Headline extends Component {
  render() {
    return <HeadlineLayout {...this.props} />;
  }
}

Headline.propTypes = { backgroundImageURL: PropTypes.string };
Headline.defaultProps = { backgroundImageURL: null };
HeadlineLayout.propTypes = Headline.propTypes;
HeadlineLayout.defaultProps = Headline.defaultProps;

export default Overridable.component("Home.Headline", Headline);
